import { useMutation } from "@tanstack/react-query";
import api from "../config/api"; 

type ValidateReCaptchaPayload = {
	captcha: string;
};

export const useValidateReCaptchaMutation = () => {
	return useMutation<boolean, Error, ValidateReCaptchaPayload>({
		mutationFn: async ({ captcha }) => {
			const response = await api.post<boolean>("/recaptcha/validate", {
				captcha,
			});

			return response.data;
		},
	});
};

export default useValidateReCaptchaMutation;
